import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MissionServices from "../pages/mission-services/page";
import GroupesBusiness from "../pages/groupes-business/page";
import RechercheInnovations from "../pages/recherche-innovations/page";
import MediasSociaux from "../pages/medias-sociaux/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mission-services",
    element: <MissionServices />,
  },
  {
    path: "/groupes-business",
    element: <GroupesBusiness />,
  },
  {
    path: "/recherche-innovations",
    element: <RechercheInnovations />,
  },
  {
    path: "/medias-sociaux",
    element: <MediasSociaux />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
